import type { DashLightingPack } from './types';

/**
 * All-opaque pack: relays / lights / switchable emeters use white fill when on.
 * Sensors and meter-only devices use glass + soft outline (info-only chrome).
 * Cury: outline (no white fill).
 */
export const OPAQUE_ALL_DASH_LIGHTING_PACK: DashLightingPack = {
	id: 'opaque-all',
	types: {
		'S4PB-00CU000002': { preset: 'white', surfaceMode: 'outline' },
	},
	categories: {
		relay: { preset: 'white', surfaceMode: 'opaque' },
		'relay-pm': { preset: 'white', surfaceMode: 'opaque' },
		light: { preset: 'white', surfaceMode: 'opaque' },
		lights: { preset: 'white', surfaceMode: 'opaque' },
		rgbw: { preset: 'white', surfaceMode: 'opaque' },
		bulb: { preset: 'white', surfaceMode: 'opaque' },
		sensor: { preset: 'white', surfaceMode: 'outline' },
		emeter: { preset: 'white', surfaceMode: 'opaque' },
		'emeter-meter': { preset: 'white', surfaceMode: 'outline' },
		power_meter: { preset: 'white', surfaceMode: 'opaque' },
		pv: { preset: 'white', surfaceMode: 'outline' },
	},
	modes: {
		light: { preset: 'white', surfaceMode: 'opaque' },
		white: { preset: 'white', surfaceMode: 'opaque' },
		color: { preset: 'white', surfaceMode: 'opaque' },
	},
	refinements: {
		// Alerts still use outline chrome in this pack (no glow wash).
		alertStatus: { preset: 'white', surfaceMode: 'outline' },
		deviceState: {
			preset: 'device-state',
			accents: {
				offline: '--color-3',
				warning: '--color-warning',
				muted: '--color-3',
			},
		},
	},
	fallback: {
		withToggle: { preset: 'white', surfaceMode: 'opaque' },
		withoutToggle: { preset: 'white', surfaceMode: 'outline' },
	},
};
